import IFunction from "./Interface/IFunction";

export default class FunctionModel implements IFunction {
    id: number | string;
    name: string;
    checked: boolean;
    change: boolean;
    relateFunc?: IFunction[]

    constructor(id?: number | string, name?: string) {
        this.id = id ?? "";
        this.name = name ?? "";
        this.checked = false;
        this.change = false;
    }
}
